import axios from "axios";
import Global from '../constant.js'
import _ from 'lodash'
import mentionUtils from "@/js/mention-utils.js";
import { computed, reactive } from "vue"
import { useStore } from 'vuex'
import {useToast} from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';

export default function () {
  // store取得
  const $store = useStore();
  const $toast = useToast();
  // states
  const mentionStates = reactive({
    accounts: null,
    groups: null,
    groupToAccounts: null,
    hashtags: null,
    mentionDestinations: null,
    mentionHashtags: null,
    circleId: null
  })
  // --- computed ---
  const account = computed(() => $store.state.core.account)
  const allAccounts = computed(() => $store.state.allAccounts.accounts)
  const circleHashtagDivisionId = computed(() => $store.state.circle.circleHashtagDivisionId)
  const circles = computed(() => $store.state.circles.circles)
  const followers = computed(() => $store.state.follows.followers)
  const hashtagDivisionId = computed(() => $store.state.square.hashtagDivisionId)
  
  // mutation操作はcommit
  const setClientErrors = (val) => $store.commit('setClientErrors', val)

  // --- methods ---
  /**
   * 
   */
  const getDestinations = async (_entryDivisionId, _circleId) => {
    if (_entryDivisionId == Global.entry_division_id.square) {
      if (allAccounts.value) {
        mentionStates.accounts = [...allAccounts.value]
        mentionStates.mentionDestinations = mentionStates.accounts.map(row => mentionUtils.getMentionStates(row))
        return
      }
    }
    if (_entryDivisionId == Global.entry_division_id.myspace) {
      mentionStates.accounts = mentionUtils.getApiResponse({data: {account_follows: followers.value}})
      mentionStates.mentionDestinations = mentionStates.accounts.map(row => mentionUtils.getMentionStates(row))
      return
    }
    let url = mentionUtils.getDestinationsUrl(_entryDivisionId)
    let params = mentionUtils.getDestinationParameters(_entryDivisionId, _circleId, account.value && account.value.id)
    console.dir(`entryDivisionId : ${_entryDivisionId}`)
    console.dir(url)
    console.dir(params)
    await axios.post(url, params).then(res => {
      if (res.data.status === Global.api_status.success) {          
        mentionStates.accounts = mentionUtils.getApiResponse(res)
        mentionStates.mentionDestinations = mentionStates.accounts.map(row => mentionUtils.getMentionStates(row))
        mentionStates.circleId = _circleId
        return
      }
    })
    .catch(error => {
      console.dir(error)
      $toast.error('client error')
      setClientErrors({func:"common/entry/tweet.vue::getDestinations", params: params, errorMessage:error})
    })
    // .finally(()=>{
      // if (_circleId != null) {
      //   getGroup(_circleId)
      // }
    // })
  }
  
  const getGroup = (_circleId) => {
    let circle = _.keyBy(circles.value, 'id')[_circleId];
    if (circle && mentionStates.groups == null) {
      mentionStates.groups = circle?.groups
      mentionStates.mentionDestinations = mentionStates.mentionDestinations.concat(mentionStates.groups?.map(row => mentionUtils.getMentionGroupsStates(row)))
      mentionStates.groupToAccounts = mentionUtils.createGroupMentionToMembersMentionConverter(mentionStates.groups)
      if (mentionStates.mentionDestinations.length > 0) {
        mentionStates.mentionDestinations = mentionStates.mentionDestinations.concat(mentionUtils.getHereState())
      }
    }
  }
  
  const getHashtags = (_entryDivisionId, _circleId) => {
    let url = mentionUtils.getHashtagsUrl(_entryDivisionId)
    let _hashtagDivisionId = _circleId ? circleHashtagDivisionId.value : hashtagDivisionId.value
    let params = mentionUtils.getHashtagsParameters(_entryDivisionId, _hashtagDivisionId, account.value && account.value.id, _circleId)
    axios.post(url, params).then(res => {
      if (res.data.status === Global.api_status.success) {
        mentionStates.hashtags = res.data.hashtags
        mentionStates.mentionHashtags = res.data.hashtags.map(row => mentionUtils.getMentionHashtagStates(_entryDivisionId, row))
        // if (_entryDivisionId === Global.entry_division_id.square) setSqureHashtags(res.data.hashtags)
      }
    })
    .catch(error=>{
      console.dir(error)
      $toast.error('client error')
      setClientErrors({func:"common/entry/tweet.vue::getHashtags", params: params, errorMessage:error})
    })
  }
  const onOpen = (_entryDivisionId, _key) => {
    if (_entryDivisionId === Global.entry_division_id.myspace) {
      mentionStates.items = mentionStates.mentionDestinations
      return
    }
    mentionStates.items = _key === '@' ? mentionStates.mentionDestinations : mentionStates.mentionHashtags
  }
  return {
    mentionStates,
    getDestinations,
    getGroup,
    getHashtags,
    onOpen,
  }
}

